module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "label-width": _vm.queryFormLabelWidth,
      "model": _vm.queryForm
    }
  }, [(_vm.commercials.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "公司名称",
      "prop": "commercial_id"
    }
  }, [(_vm.commercials.length > 1) ? _c('el-select', {
    attrs: {
      "placeholder": "全部"
    },
    on: {
      "change": function($event) {
        return _vm.getShopList()
      }
    },
    model: {
      value: (_vm.queryForm.commercial_id),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "commercial_id", $$v)
      },
      expression: "queryForm.commercial_id"
    }
  }, _vm._l((_vm.commercials), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.commercials.length == 1) ? _c('el-input', {
    attrs: {
      "type": "text",
      "value": _vm.commercials[0].name,
      "disabled": ""
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shops.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "shop_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "remote-method": _vm.remoteShopMethod,
      "placeholder": "请输入店铺"
    },
    model: {
      value: (_vm.queryForm.shop_id),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "shop_id", $$v)
      },
      expression: "queryForm.shop_id"
    }
  }, _vm._l((_vm.shopList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "dateType"
    }
  }, [_c('el-select', {
    staticClass: "fl",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.dateType),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "dateType", $$v)
      },
      expression: "queryForm.dateType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "下单日期",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "送达日期",
      "value": "2"
    }
  })], 1), _vm._v(" "), _c('el-date-picker', {
    staticClass: "fl ml10",
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "placeholder": "请选择日期"
    },
    on: {
      "change": function($event) {
        return _vm.changeDate()
      }
    },
    model: {
      value: (_vm.queryForm.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "dateRange", $$v)
      },
      expression: "queryForm.dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单号",
      "prop": "orderId"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.queryForm.orderId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "orderId", $$v)
      },
      expression: "queryForm.orderId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付方式",
      "prop": "payway"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.payway),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "payway", $$v)
      },
      expression: "queryForm.payway"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "微信",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "支付宝",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "银联",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "校园卡",
      "value": "4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.fetchData(_vm.queryForm.pageNo = 1)
      }
    }
  }, [_vm._v("查询列表")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getSummary()
      }
    }
  }, [_vm._v("查询汇总")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('queryForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.summary.totalCost || _vm.summary.totalCost === 0) ? _c('div', [_c('div', {
    staticClass: "red pb10"
  }, [_vm._v("说明：此报表未扣除退款订单金额")]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card mb20",
    staticStyle: {
      "background-color": "#eaf5fc"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', [_vm._v("\n                            结算金额\n                            "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "结算金额＝供货总价－佣金",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "red f12"
  }, [_vm._v("＋"), _c('span', {
    staticClass: "f20 plr2"
  }, [_vm._v(_vm._s(_vm.summary.totalIncome || 0))]), _vm._v("元")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', [_vm._v("\n                            供货总价\n                            "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "供货总价＝供货总价（元）汇总",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "red f12"
  }, [_vm._v("＋"), _c('span', {
    staticClass: "f20 plr2"
  }, [_vm._v(_vm._s(_vm.summary.totalCost || 0))]), _vm._v("元")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', [_vm._v("\n                            订单总量\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "red f12"
  }, [_c('span', {
    staticClass: "f20 plr2"
  }, [_vm._v(_vm._s(_vm.summary.totalNumber || 0))])])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "pb20"
  }, [(_vm.showExport) ? _c('export-excel', {
    attrs: {
      "params": _vm.exportParams,
      "action": _vm.$apiUrl.financeTransactionBill,
      "target": 'oc',
      "field": _vm.field,
      "filename": _vm.fileName,
      "fieldname": _vm.fieldName
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.downLoadHistoryData()
      }
    }
  }, [_vm._v("历史数据下载")]), _vm._v(" "), _c('span', {
    staticClass: "primary f12"
  }, [_vm._v("如需查询时间跨度大于一周的数据，请使用历史数据下载功能")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.getTableData
    },
    model: {
      value: (_vm.queryForm.orderStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "orderStatus", $$v)
      },
      expression: "queryForm.orderStatus"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "0"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已支付",
      "name": "1001"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已完成",
      "name": "2002"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已取消",
      "name": "9000"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "commercialName",
      "label": "公司名称",
      "show-overflow-tooltip": true,
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "supplierShortName",
      "label": "店铺名称",
      "show-overflow-tooltip": true,
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "订单号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "costAmount",
      "label": "供货总价(元)",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "paywayStr",
      "label": "支付方式",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusCreateTime",
      "label": "下单时间",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deliveryTime",
      "label": "送达时间",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderStatus",
      "label": "订单状态",
      "show-overflow-tooltip": true,
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "fixed": "right",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewDetail(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewRecord(scope.row)
            }
          }
        }, [_vm._v("配送日志")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNo,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.pageSize,
      "prev-text": "上一页",
      "next-text": "下一页",
      "layout": "prev, next"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "交易明细",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.gridData
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "title",
      "label": "商品名称",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "costPrice",
      "label": "供货价(元)",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "number",
      "label": "数量",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "commission",
      "label": "佣金(元)",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "costAmount",
      "label": "供货总价(元)",
      "width": ""
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "进程状态",
      "visible": _vm.recordVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.recordVisible = $event
      }
    }
  }, _vm._l((_vm.recordDetail), function(r) {
    return _c('el-card', {
      key: r.executionTime,
      staticClass: "box-card mb15"
    }, [_c('p', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(r.progressInfo))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(r.handlers) + " " + _vm._s(r.handlersTel))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$utils.formatDate(r.executionTime)))])])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-716767e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/finance/transaction.vue
// module id = 923
// module chunks = 0